import { cn } from '@bem-react/classname';

export const cnPagination = cn('Pagination');
export const cnPagesNext = cnPagination('PagesNext');
export const cnPagesPrev = cnPagination('PagesPrev');
export const cnPagesSrOnly = cnPagination('SrOnly');
export const cnPagesGap = cnPagination('PagesGap');
export const cnPageInput = cnPagination('PageInput');
export const cnPageInputLabel = cnPagination('PageInputLabel');
export const cnPageSizeSelect = cnPagination('PageSizeSelect');
export const cnPageControls = cnPagination('Controls');
